export const createCryptoWorker = () => {
  const workerEntry = './worker.ts';
  let worker: Worker;

  try {
    worker = new Worker(new URL('./worker.ts', import.meta.url), { type: 'module' });
  } catch {
    worker = new Worker(new URL('./worker.ts', import.meta.url));
  }

  worker.onerror = (errorEvent: ErrorEvent) => {
    console.error('[crypto] webWorker error', {
      workerEntry,
      type: errorEvent.type,
      message: errorEvent.message,
      filename: errorEvent.filename,
      lineno: errorEvent.lineno,
      colno: errorEvent.colno,
      error: errorEvent.error,
    });
  };
  worker.onmessageerror = (event: MessageEvent) => {
    console.error('[crypto] webWorker message error', {
      workerEntry,
      event,
    });
  };

  return worker;
};
